import React from 'react';
import PropTypes from 'prop-types';
import { FiTrash2 } from 'react-icons/fi';
import {
  Button,
  TextInput,
  ToolTip,
} from '../../../../components';

/* WARNING: This component assumes any props passed are immutable
 * E.G. If you update the benefit.name in a parent component, this component
 * will not re-render. You must pass a new benefit object with the new name.
 * (const newBenefit = { ...oldBenefit, name: newName };)
*/

const propTypes = {
  benefitCategory: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
  }).isRequired,
  onChange: PropTypes.func.isRequired,
  onOpenDelete: PropTypes.func.isRequired,
};

function EditPlanBenefitCategory({
  benefitCategory,
  onChange,
  onOpenDelete,
}) {
  const handleChange = event => onChange(event, benefitCategory.id);
  const handleOpenDelete = () => onOpenDelete(benefitCategory.id);
  return (
    <tr>
      <td>
        <TextInput
          name="text"
          value={benefitCategory.name}
          onChange={handleChange}
        />
      </td>
      <td>
        <ToolTip content="Delete plan benefit category">
          <Button
            variant="danger"
            onClick={handleOpenDelete}
            iconStart={<FiTrash2 />}
            aria-label="Delete plan benefit category"
          />
        </ToolTip>
      </td>
    </tr>
  );
}

EditPlanBenefitCategory.propTypes = propTypes;
export default React.memo(EditPlanBenefitCategory);
